



















































































































import { Vue, Component } from "vue-property-decorator";
import {
  Member,
  PendingMember,
  ToggleTeamMemberStatusPayload,
} from "@/modules/team/types";
import { User } from "@/modules/auth/types";
import { namespace } from "vuex-class";
import { translateRole } from "../utils";
import { AxiosResponse } from "node_modules/axios";

const Team = namespace("team");
const Auth = namespace("auth");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Team",
    };
  },
  filters: {
    translateRole,
  },
})
export default class TeamTable extends Vue {
  @Team.Action("fetchMembers") fetchMembers!: () => Promise<{}>;
  @Team.Action("fetchPendingMembers") fetchPendingMembers!: () => Promise<{}>;
  @Team.Getter("getAllMembers") members: Member[];
  @Team.Getter("getAllPendingMembers") pendingMembers: PendingMember[];
  @Auth.Getter("getUser") user!: User;
  @Team.Action("toggleTeamMemberStatus") toggleTeamMemberStatus!: (
    payload: ToggleTeamMemberStatusPayload
  ) => Promise<AxiosResponse>;

  options = {
    tooltipStyle: {
      opacity: "0",
    },
    railStyle: {
      width: "100%",
      height: "6px",
      backgroundColor: "#E8F1FB",
    },
    processStyle: {
      backgroundColor: "rgba(61, 113, 227, var(--bg-opacity))",
    },
    dotOptions: [
      {
        style: {
          width: "22px",
          height: "22px",
          background: "rgba(61, 113, 227, var(--bg-opacity))",
          border: "5px solid #002583",
          marginTop: "-5.5px",
        },
      },
    ],
  };

  toggleStatus(memberId: string, event) {
    const action = event.target.checked ? "enable" : "disable";
    this.toggleTeamMemberStatus({
      action: action,
      memberId,
    })
      .then(() => {
        this.$notify({
          group: "success",
          title: "Success",
          text: `Team member ${action}d successfully.`,
        });
        this.fetchMembers();
      })
      .catch(() => {
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to disable team member.",
        });
      });
  }

  async beforeMount() {
    this.fetchMembers();
    this.fetchPendingMembers();
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
